import { MARKETING_SITE_BASE_URL } from '../../../Shared/CompanySpecificStrings';

export const FCRA_COMPLIANCE_URL =
    'https://www.ftc.gov/system/files/documents/statutes/fair-credit-reporting-act/545a_fair-credit-reporting-act-0918.pdf';

// CFPB "A Summary of Your Rights Under the Fair Credit Reporting Act" — the document the
// rental history verification release attests the applicant received, so the consent page must
// actually provide it.
export const FCRA_SUMMARY_OF_RIGHTS_URL =
    'https://files.consumerfinance.gov/f/201504_cfpb_summary_your-rights-under-fcra.pdf';

export const TERMS_OF_SERVICE_URL = `${MARKETING_SITE_BASE_URL}/terms-of-service`;
export const PRIVACY_POLICY_URL = `${MARKETING_SITE_BASE_URL}/privacy-policy`;
